import cx from 'classnames'
import React, { ButtonHTMLAttributes, ReactNode } from 'react'

import * as styles from './searchbar-icon-button.module.css'

const BTN_SIZE_TOGGLE = 32
const BTN_SIZE_INPUTS = 28

interface SearchBarIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  children: ({ toggleSize, inputSize }: { toggleSize: number; inputSize: number }) => ReactNode
}

const SearchBarIconButton: React.FC<SearchBarIconButtonProps> = ({ className = '', children, ...props }) => {
  return (
    <button className={cx(styles.searchbarButton, className)} type="button" {...props}>
      {children({ toggleSize: BTN_SIZE_TOGGLE, inputSize: BTN_SIZE_INPUTS })}
    </button>
  )
}

export default SearchBarIconButton
